// AI behavior rules. See docs/04-equipment-craft §4.2 / §4.2.1 / §4.10
// and docs/05-combat-sim §5.6.
//
// Six categories drive AI decisions: four core (Targeting, Movement, Tempo,
// ThreatPolicy), and two auxiliary (PositionPolicy, DamageReact). Belt and
// cloak supply parallel triggers but are not part of the core dispatch order.
export const BEHAVIOR_CATEGORIES = [
    'targeting',
    'movement',
    'tempo',
    'threatPolicy',
    'positionPolicy',
    'damageReact',
    'trigger',
    'startBuff',
];
export const TARGETING_RULES = [
    'target_nearest',
    'target_farthest',
    'target_lowest_hp',
    'target_lowest_hp_pct',
    'target_highest_hp',
    'target_highest_threat',
    'target_attacker',
    'target_afflicted',
];
export const MOVEMENT_RULES = [
    'move_melee_stick',
    'move_distance_short',
    'move_distance_mid',
    'move_distance_long',
    'move_kite_circle',
    'move_anchor_lock',
];
export const TEMPO_RULES = [
    'tempo_conserve',
    'tempo_burst',
    'tempo_conditional',
    'tempo_executor',
    'tempo_dot_focus',
    'tempo_ult_focus',
];
export const THREAT_POLICY_RULES = [
    'threat_high',
    'threat_overdrive',
    'threat_neutral',
    'threat_low',
    'threat_defender',
];
export const POSITION_POLICY_RULES = [
    'pos_behind_tank_anchor',
    'pos_behind_target',
    'pos_flank_target_left',
    'pos_flank_target_right',
    'pos_ally_triangle',
    'pos_avoid_overlap',
    'pos_safe_line',
];
/** Catalogue of MVP DamageReact rules. See docs/04 §4.2.1 DamageReact. */
export const DAMAGE_REACT_RULES = [
    'react_hp50_kite',
    'react_hp25_emergency',
    'react_hp25_lastditch',
    'react_shield_break_retreat',
    'react_ally_low_support',
    'react_hp50_threat_drop',
    'react_focused_hide',
    'react_ally_critical_ult',
    'react_self_buffed_aggro',
];
//# sourceMappingURL=behavior.js.map